var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubmit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8325 4.18489C21.9118 4.27319 21.9661 4.38545 21.9885 4.50772C22.0109 4.62999 22.0005 4.75689 21.9585 4.87264L15.2894 23.3998C15.2306 23.5629 15.1325 23.7049 15.0058 23.8101C14.8791 23.9153 14.7287 23.9795 14.5712 23.9959C14.4137 24.0122 14.2553 23.9799 14.1132 23.9026C13.9712 23.8253 13.8511 23.706 13.7662 23.5577L10.1239 17.196L4.39913 13.1485C4.2654 13.0543 4.15771 12.9208 4.08793 12.7628C4.01816 12.6048 3.98901 12.4285 4.00371 12.2532C4.01841 12.078 4.07639 11.9107 4.17124 11.7698C4.2661 11.6289 4.39414 11.5198 4.54125 11.4546L21.2136 4.04607C21.3177 3.99947 21.4319 3.98791 21.542 4.01281C21.652 4.03772 21.753 4.098 21.8325 4.18617V4.18489ZM11.2677 16.8241L14.4321 22.349L19.8566 7.27975L11.2677 16.8241ZM19.0463 6.37931L5.48564 12.4073L10.4586 15.9224L19.0463 6.37931Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmit);
export default __webpack_public_path__ + "static/media/submit.4dfa9f1b9257fd8953a3a1e651767605.svg";
export { ForwardRef as ReactComponent };